// import Link from "next/link";
import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import styles from "./mobile-header.module.scss";

function Link(props: any) {
  const { children, href, as } = props;
  const router = useRouter();

  function handleClick() {
    if (as) {
      router.push(href, as);
    } else {
      router.push(href);
    }
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a onClick={handleClick}>
      {children}
    </a>
  );
}

function MobileAccountDropdown(props: any) {
  const { firstName, onSignOut, onClose } = props;
  const { t } = useTranslation("common");

  return (
    <div style={{ color: "#7f501a", width: "calc(24 * var(--safari-root-font, 10px))", margin: "calc(-1.5 * var(--safari-root-font, 10px))" }}>

      <>

        <h3 className={styles.section_heading}>
          {`${t("welcome_user", { name: firstName })} !`}
        </h3>

        <div className={styles.section} onClick={onClose}>

          <Link prefetch={false} href="/account/overview">

            <span className={styles.text_label}>{t("Account")}</span>
          </Link>
        </div>

        <div className={styles.section} onClick={onClose}>

          <Link prefetch={false} href="/account/orders">

            <span className={styles.text_label}>{t("Orders")}</span>
          </Link>
        </div>

        <div className={styles.section} onClick={onClose} style={{ borderBottom: "calc(0.1 * var(--safari-root-font, 10px)) solid #d9d8db" }}>

          <Link prefetch={false} href="/account/wishlist">

            <span className={styles.text_label}>{t("Wish List")}</span>
          </Link>
        </div>

        <div className={styles.section} onClick={onClose}>

          <Link prefetch={false} href="/account/orders">

            <span className={styles.text_label}>{t("Track Order")}</span>
          </Link>
        </div>

        <div className={styles.section} onClick={onClose}>

          <Link
            prefetch={false}
            href="/questions-about-autoparts"
          >

            <span className={styles.text_label}>FAQ</span>
          </Link>
        </div>

        <div className={styles.section} onClick={onClose}>

          <Link
            prefetch={false}
            href="/contact-us-for-car-parts"
          >

            <span className={styles.text_label}>{t("Contact us")}</span>
          </Link>
        </div>

        <PAButton
          style={{ idth: 200, marginBottom: 10 }}
          buttonType={BUTTON_TYPE.OUTLINE}
          onClick={onSignOut}
        >
          {t("PopUpSignedInAccount.Sign_Out")}
        </PAButton>
      </>
    </div>
  );
}

export default MobileAccountDropdown;
